<template>
  <Modal open :title="__('Edit contact')" @close="handleCancelButtonClick">
    <form
      @submit.prevent="submit"
      class="grid grid-cols-4 gap-5 rounded-md bg-zinc-100 p-6"
    >
      <div class="col-span-2">
        <div class="w-full">
          <label
            class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >{{ __('First name') }}</label
          >
          <InputText
            type="text"
            v-model="form.first_name"
            :value="form.first_name"
            :placeholder="__('First name')"
            id="first_name"
            name="first_name"
            required
          />
        </div>
      </div>

      <div class="col-span-2">
        <div class="w-full">
          <label
            class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >{{ __('Last name') }}</label
          >
          <InputText
            type="text"
            v-model="form.last_name"
            :value="form.last_name"
            :placeholder="__('Last name')"
            id="last_name"
            name="last_name"
            required
          />
        </div>
      </div>

      <div class="col-span-2">
        <div class="w-full">
          <label
            class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >{{ __('Email') }}</label
          >
          <InputText
            type="text"
            v-model="form.email"
            :value="form.email"
            :placeholder="__('Email')"
            id="email"
            name="email"
            required
          />
        </div>
      </div>

      <div class="col-span-2">
        <div class="w-full">
          <label
            class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >{{ __('Source') }}</label
          >
          <div class="relative">
            <FormSingleselect
              v-model="form.contact_source"
              :values="contact_sources"
              type="static"
            />
          </div>
        </div>
      </div>

      <div class="col-span-4">
        <div class="w-full">
          <label
            class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >{{ __('Link') }}</label
          >
          <InputText
            type="text"
            v-model="form.link"
            :value="form.link"
            :placeholder="__('Link')"
            id="link"
            name="link"
          />
        </div>
      </div>

      <div class="col-span-4">
        <div class="w-full">
          <label
            class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >{{ __('Phone') }}</label
          >
          <div class="relative">
            <div class="absolute w-[42%] lg:w-[30%]">
              <FormSingleselect
                v-model="form.country_code"
                :values="country_codes"
                type="static"
              />
            </div>
            <div class="[&>input]:pl-[45%] lg:[&>input]:pl-[32%]">
              <InputText
                v-model="form.phone"
                :value="form.phone"
                type="text"
                :placeholder="__('Phone')"
                id="phone"
                name="phone"
              />
            </div>
          </div>
        </div>
      </div>

      <InputLocation
        v-model:value="form.location"
        :label-country="__('Country')"
        :label-city="__('City')"
        :placeholder-country="__('Add country')"
        :placeholder-city="__('Add city')"
        :options="countries"
        :default-country="defaultCountry"
        class="col-span-4"
      />

      <div class="col-span-4 flex justify-center gap-2">
        <button
          type="submit"
          class="block rounded-md bg-brandColor1 px-3 py-2 text-center text-sm text-white shadow-sm"
        >
          {{ __('Save') }}
        </button>
        <button
          @click="onToggleForm"
          type="button"
          class="text-center text-sm font-semibold text-brandColor1"
        >
          {{ __('Cancel') }}
        </button>
      </div>
    </form>
  </Modal>
</template>

<script setup>
  import axios from 'axios';
  import { inject, ref } from 'vue';
  import { __ } from '../../../../../helpers';
  import { InputText } from '../../../../global';
  import FormSingleselect from '../../../../global/Form/FormSingleselect.vue';
  import { InputLocation } from '@/components/form/input-location';
  import { Modal } from '@/components/block/modal';
import { useToast } from 'vue-toastification';

  const props = defineProps({
    country_codes: Array,
    contact_sources: Array,
    countries: Array,
    defaultCountry: Object,
    selectedJob: Object
  });

  const toast = useToast();

  const form = inject('form');
  const loadUsers = inject('loadUsers');

  const emit = defineEmits(['toggleForm']);

  function onToggleForm() {
    emit('toggleForm');
  }

  function submit() {
    if (form.value.country_code) {
      form.value.country_prefix = form.value.country_code?.id;
    }
    if (form.value.contact_source != null) {
      form.value.source = form.value.contact_source?.id;
    }

    form.value.job_id = props.selectedJob?.id;
    form.value.city_id = form.value.location
      ? form.value.location.city?.id
      : null;

    axios
      .post(route('redesign.company.contacts.update'), form.value)
      .then(function (response) {
        toast.success(response.data.message);
        loadUsers();
      })
      .catch(function (err) {
        toast.error(err.response.data.message || __('Something went wrong.'));
      });
    emit('toggleForm');
  }
</script>
